<template>
    <span>
        <b-button
            :disabled="synchronizing || disabled"
            variant="primary"
            v-b-modal.modal-po-sync
            class="sync-po-btn ml-2 btn-lte"
            v-b-tooltip.hover
            :title="$t('sync_dialog_title')"
        >
            <font-awesome-icon icon="sync"></font-awesome-icon>
            <b-badge pill variant="dark" v-if="syncCount > 0">
                {{ syncCount }}
            </b-badge>
        </b-button>
        <b-modal
            id="modal-po-sync"
            :title="$t('sync_dialog_title')"
            hide-footer
            size="lg"
        >
            <div v-if="isNew" class="alert alert-warning" role="alert">
                Please, synchronize order(s)!
            </div>

            <div>
                <b-form-input
                    v-model="keyword"
                    :placeholder="$t('search_pos')"
                    class="filter-po-list mb-3"
                    type="search"
                    @input="searchPo"
                ></b-form-input>

                <div class="" v-if="filteredPoList.length > 0">
                    <b-form-checkbox-group v-model="selected">
                        <b-table-simple
                            small
                            hover
                            responsive
                            class="table-open-po"
                        >
                            <b-thead>
                                <b-tr>
                                    <b-th></b-th>
                                    <b-th>{{ $t("po_number") }}</b-th>
                                    <b-th>{{ $t("due_on") }}</b-th>
                                    <b-th class="text-right">{{
                                        $t("product_count")
                                    }}</b-th>
                                    <b-th class="text-right">{{
                                        $t("remaining_quantity")
                                    }}</b-th>
                                </b-tr>
                            </b-thead>
                            <b-tbody>
                                <b-tr
                                    v-for="option in filteredPoList"
                                    :key="option.id"
                                    @click.stop.prevent="
                                        modifySelectedPo(option.id)
                                    "
                                >
                                    <b-td>
                                        <b-form-checkbox
                                            :value="option.id"
                                            :name="option.id.toString()"
                                        ></b-form-checkbox>
                                    </b-td>
                                    <b-td>
                                        {{ option.po_number }}
                                        <span
                                            v-if="option.comment"
                                            v-b-tooltip.hover
                                            :title="option.comment"
                                            class="ml-2"
                                        >
                                            <font-awesome-icon
                                                icon="comment"
                                            ></font-awesome-icon>
                                        </span>
                                    </b-td>
                                    <b-td>{{ option.due_date }}</b-td>
                                    <b-td class="text-right">{{
                                        option.rowsToAdd
                                    }}</b-td>
                                    <b-td class="text-right">{{
                                        option.remainingQuantity
                                    }}</b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </b-form-checkbox-group>

                    <div class="d-flex justify-content-between align-items-center">
                        <b-form-checkbox
                            v-model="selectAllPurchaseOrders"
                            class="mx-1"
                            @change="selectAll"
                        >
                            {{ $t("select_all") }}
                        </b-form-checkbox>
                        <b-button
                            variant="primary"
                            @click="synchronizePurchaseOrders"
                            :disabled="!selected.length"
                        >
                            {{
                                $t("synchronize_button", {
                                    amount: selected.length,
                                })
                            }}
                        </b-button>
                    </div>
                </div>

                <div v-else>
                    <b-alert show variant="info">{{ $t("nothing_to_sync") }}</b-alert>
                </div>
            </div>
        </b-modal>
    </span>
</template>

<style scoped>
.filter-po-list {
  max-width: 220px;
}

.table-open-po th,
.table-open-po td {
  vertical-align: middle;
}

.custom-control-inline {
  margin: 0;
}
</style>

<script>
import axios from "axios";

export default {
  props: {
    report: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isNew: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      synchronizing: false,
      syncCount: 0,
      keyword: "",
      selectAllPurchaseOrders: false,
      selected: [],
      filteredPoList: [],
      openPurchaseOrders: []
    };
  },
  mounted() {
    this.synchronizePurchaseOrderCount();
    if (this.isNew) {
      this.getPurchaseOrders();
      this.$bvModal.show("modal-po-sync");
    }
    this.$root.$on("bv::modal::show", () => {
      this.getPurchaseOrders();
    });
  },
  methods: {
    modifySelectedPo(id) {
      let idx = this.selected.indexOf(id);
      if (idx === -1) {
        this.selected.push(id);
      } else {
        this.selected.splice(idx, 1);
      }
    },
    searchPo() {
      // Search by PO number
      this.filteredPoList = this.openPurchaseOrders.filter(po => {
        return po.po_number.toLowerCase().includes(this.keyword.toLowerCase());
      });
    },
    selectAll() {
      this.selected = this.selectAllPurchaseOrders
        ? []
        : this.filteredPoList.map(po => po.id);
    },
    synchronizePurchaseOrders() {
      this.synchronizing = true;
      axios
        .post(`/api/reports/${this.report.id}/purchase-orders`, {
          purchase_orders: this.selected
        })
        .then(r => {
          this.syncCount = 0;
          this.$emit("synchronized", r.data.additionCount);
        })
        .finally(() => {
          this.synchronizing = false;
          // Hide the modal and reset stuff
          this.$bvModal.hide("modal-po-sync");
          this.filteredPoList = [];
          this.selected = [];
        });
    },
    synchronizePurchaseOrderCount() {
      axios
        .get(`/api/reports/${this.report.id}/purchase-orders/quantity`)
        .then(r => {
          this.syncCount = r.data.additionCount;
          _.delay(this.synchronizePurchaseOrderCount, 10000);
        });
    },
    getPurchaseOrders() {
      axios.get(`/api/reports/${this.report.id}/purchase-orders`).then(r => {
        this.openPurchaseOrders = r.data.data;
        this.filteredPoList = this.openPurchaseOrders;
      });
    }
  }
};
</script>
